<template>
    <div class="time-line">
        <div class="time-line-item" v-for="item in items">
            <slot name="item" :item="item">
                <strong class="d-block">{{ item[name] }}</strong>
            </slot>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
            name: {
                type: String,
                'default': 'name',
            },
        },
    }
</script>
<style lang="scss">
    $timeLineColor: #009DFA ! default;

    .time-line {
        border-left: 2px solid $timeLineColor;
        padding-bottom: 15px;

        .time-line-item {
            position: relative;
            padding-left: 15px;

            &:before {
                position: absolute;
                top: 8px;
                left: -6px;
                content: ' ';
                width: 10px;
                height: 10px;
                background: $timeLineColor;
                border-radius: 50%;
            }

            ul {
                list-style: none;
                padding: 0;
                margin: 0;
                font-size: 13px;
                line-height: 13px;
                display: block;

                strong {
                    font-size: 16px;
                    line-height: 16px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/core/TimeLine.vue